import { Component, OnInit, Output, EventEmitter, Input, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { transition, animate, style, trigger } from '@angular/animations';
import { CustomerSelectItem, EquipmentSelectItem } from '../../setup-equipment/setup-equipment.model';
import { ApiResponse, GenericIdName, GenericIdNameVM, GETGenericIdName, ImplementTypeVM } from '../../setup-implement/setup-implement.model';
import { GETSetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { SearchFilters } from '../search-panel/search-panel.model';
import { MatDialog } from '@angular/material/dialog'; import { FavouriteDialogService } from '../../favourite-dialog/favourite-dialog.service';
import { JobsiteSelectionFilter, ModelSelectionFilter, ImplementSelectionFilter, ComponentTypeSelectionFilter, SerialNOSelectionFilter, AssetSerialSelectionFilter, FamilyList } from '../../favourite-dialog/favourite-dialog-modal';
import { ProgramImprovementService } from '../../services/program-improvement.service';
import { PipForDashboardComponent } from '../../../../modules/ProductImprovement/pip-for-dashboard/pip-for-dashboard.component';
import { ComponentForecastService } from '../../../../modules/component-forecast/component-forecast.service';
import { ImplementDetailsService } from '../../implement-details/implement-details.service';
import { FormControl } from '@angular/forms';
import { MatChipInputEvent, } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatSelectChange } from '@angular/material/select';



interface Jobsite {

  Id: number;
  Name: string;
}
@Component({
  selector: 'search-panel',
  templateUrl: './search-panel.component.html',
  styleUrls: ['./search-panel.component.scss'],
  animations: [
    trigger(
      'fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 0 }),
        animate('0ms', style({ opacity: 0 }))
      ])
    ],
    ),
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ height: '1px', opacity: 0 }),
        animate('250ms', style({ height: '324px', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '324px', opacity: 1 }),
        animate('250ms', style({ height: '1px', opacity: 0 }))
      ])
    ]
    )
  ]
})
export class SearchPanelComponent implements OnInit {
  showSearch: boolean = true;
  equipmentCtrl = new FormControl();
  assetAltCtrl = new FormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  customerList: CustomerSelectItem[] = [];
  selectedCustomers: any[] = [];
  filteredCustomers: any[] = [...this.customerList];
  equipmentList: any[] = [];
  equipmentList_: EquipmentSelectItem[] = [];
  filteredEquipmentList: any = [];
  filteredFamilies: GenericIdName[] = [];
  @ViewChild('chipInput') chipInput: ElementRef<HTMLInputElement>;
  @ViewChild('implementTypeInput') implementTypeInput: any;
  @ViewChild('assetTypeInput') assetTypeInput: any;
  @ViewChild('makeInput') makeInput: any;
  @ViewChild('assetMakeInput') assetMakeInput: ElementRef<HTMLInputElement>;
  @ViewChild('modelInput') modelInput: ElementRef<HTMLInputElement>;
  @ViewChild('jobsiteInput') jobsiteInput: ElementRef<HTMLInputElement>;
  @ViewChild('familychipInput') familychipInput: ElementRef<HTMLInputElement>;
  @ViewChild('equipmentInput') equipmentInput: ElementRef<HTMLInputElement>;
   @ViewChild('assetMakeInput') assetSerialInput: ElementRef<HTMLInputElement>;

  AssetSerialList_: GenericIdName[] = [];
  //AssetSerialALTList: GenericIdName[] = [];
  AssetSerialALTList_: GenericIdName[] = [];
  copyimplementList: GETGenericIdName[] = [];
  copyimplementTypeList: ImplementTypeVM[] = [];
  copycomponentTypeList: GenericIdName[] = [];
  onEqS: number = 3;

  // Search Filters
  selectedCustomer: number[] = [];
  selectedJobsite: number[] = [];
  //selectedJobsite: number[] = [];
  selectedEquipment: any[] = [];
  selectedMake: number[] = [];
  selectedMakeUC: number[] = [];
  // Add these properties to manage Families
  selectedFamilies: any[] = [];
  selectedAssetType: any[] = [];
  selectedComponentType: number[] = [];
  selectGETTypeId: number[] = [];
  selectedFamily: number[] = []
  implementTypeControl = new FormControl();
  implementTypeList = [];
  familyList: any[] = [];
  selectedModel: number[] = [];
  selectedImplement: number[] = [];
  selectedImplementType: number[] = [];
  showMultipleAssetAlt: boolean = true; // To toggle visibility
  AssetSerialALTList: any[] = []; // List of all available Asset Alt. Numbers
  filteredAssetALTList: any[] = []; // Filtered list for autocomplete
  selectedAssetALT: any[] = []; // Selected Asset Alt. Numbers
  selectedAssetALTInput: string = ''; // Input text for autocomplete
  selectedEquipmentList: any[] = [];
  selectedAssetMake: any = [];
  selectedAssetMakes: any = []; // Array to hold selected asset makes
  assetMakeList = []; // Array to hold all available asset makes
  selectedEquipmentInput: string = ''; // Input for searching equipmen
  implementList: GETGenericIdName[] = [];
  componentTypeList = [];
  filteredComponentTypes = [];
  selectedComponentTypes: { Name: string }[] = [];
  filteredAssetMakes: any = [];
  selectedImplementTypes: any[] = [];
  filteredImplementTypes: any[] = [];
  jobsiteCtrl = new FormControl();
  filteredJobsites: any[] = [];
  selectedJobsites: any[] = [];
  jobsiteList: any[] = [];
  showMultipleAssetSerial = true;  // Set this based on your logic
  selectedAssetSerial: any[] = [];  // This will store selected asset serial numbers
  selectedAssetSerialInput: string = '';  // This binds to the input field
  AssetSerialList: any[] = [];  // Your complete list of asset serial numbers
  filteredAssetSerialList: any[] = [];  // The filtered list for autocomplete
  selectedAssetSerials: any = [];
  filteredAssetSerials: any = [];
  selectedMakes: any[] = []; // Array to hold selected makes
  makeList: any[] = []; // This should be the list of all available makes
  filteredMakes: any[] = []; // Filtered list based on user input
  selectedAssetTypes: any[] = []; // Array to hold selected asset types
  GETTypeList: any[] = []; // This should be the list of all available asset types
  filteredAssetTypes: any[] = [];
  selectedModels = [];  // Array to hold selected models
  modelList = [];  // Array to hold all available models
  filteredModels = [];
  showText: boolean = false
  implementIDList: number[] = []
  numberofNotifications: number
  EvalA: boolean = true;
  EvalB: boolean = true;
  EvalC: boolean = true;
  EvalX: boolean = true;
  onEq: boolean = true;

  NoImps: boolean = false;
  showMultiple: boolean = true;
  selectedEquipment_
  selectedEquipmentval


  //  showMultipleAssetSerial:boolean=true;
  selectedAssetSerial_

  //showMultipleAssetAlt:boolean=true;
  selectedAssetALT_
  selectedAssetAltval
  selectedEquipments: any[] = [];

  GET_Auto: number[] = []
  @Output() searchFilters: EventEmitter<SearchFilters> = new EventEmitter<SearchFilters>();
  @Output() implementforDashboard: EventEmitter<any> = new EventEmitter<any>();
  @Output() Reset: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() selectedTab: number;
  constructor(private _equipmentService: GETSetupEquipmentService,
    private _impService: ImplementDetailsService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private _favouriteDialogService: FavouriteDialogService,
    private _programImprovementService: ProgramImprovementService,
    public _fleetService: ComponentForecastService,) {
    this.filteredJobsites = this.jobsiteList;
    this.filteredImplementTypes = this.implementTypeList;
  }

  ngOnInit() {
    this.LoadGETTypesList();
    this.loadCustomers();
    this.loadMakes();
    this.LoadAllImplements();
    this.LoadAllImplementTypes();
    this.getUserAlertsforDashbpard();
    this.loadAllFamilyList();
    this.loadComponentTypes();
  this.GetAssetSerialSelectedImplements();
    this.filteredJobsites = this.jobsiteList;

  }
  // Filter customers based on input
  filterCustomers(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredCustomers = this.customerList.filter(customer =>
      customer.Name.toLowerCase().includes(filterValue) &&
      !this.selectedCustomers.some(c => c.Name === customer.Name)
    );
  }
  // Select customer from autocomplete
  selectCustomer(event: any): void {
    const customerName = event.option.value;
    const selectedCustomer = this.customerList.find(c => c.Name === customerName)

    if (selectedCustomer && !this.selectedCustomers.some(c => c.Name === selectedCustomer.Name)) {
      this.selectedCustomers.push(selectedCustomer);
      this.selectedCustomer.push(selectedCustomer.Id);
    }
    // Clear input
    this.filterCustomers('');
    this.loadFamiliesForCustomer();
    this.loadJobsitesForCustomer();
    this.chipInput.nativeElement.value = '';
    this.filterCustomers('');
    this.loadGETTypes();
  }

  // Remove a customer chip
  removeChip(chip: any): void {
    const index = this.selectedCustomers.indexOf(chip);
    if (index >= 0) {
      this.selectedCustomers.splice(index, 1);
      this.selectedCustomer.splice(index, 1);
    }
    this.loadAllFamilyList();
    this.loadJobsitesForCustomer();
    this.filterCustomers('');
    if (this.selectedJobsite?.length === 0) {
      this.GETTypeList = [];
      this.filteredAssetTypes = [];
      return;
    }
  }

  showSearchPanel() {
    this.showSearch = !this.showSearch;
  }

  filterComponentTypes(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredComponentTypes = this.componentTypeList.filter(compType =>
      compType.Name.toLowerCase().includes(filterValue)
    );
    if (value == "") {
      this.filteredComponentTypes = this.componentTypeList;
    }
  }

  addComponentType(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    const selectedComponentType = this.filteredComponentTypes.find(make => make.Name.toLowerCase() === value.toLowerCase());
    if (selectedComponentType && !this.selectedComponentTypes.includes(selectedComponentType)) {
      this.selectedComponentTypes.push(selectedComponentType);
    }
    event.chipInput!.clear();
    this.filterComponentTypes('');
  }

  // Remove component type from selected list
  removeComponentType(compType: { Name: string }): void {
    const index = this.selectedComponentTypes.indexOf(compType);
    if (index >= 0) {
      this.selectedComponentType.splice(index, 1);
      this.selectedComponentTypes.splice(index, 1);
    }
  }

  // Handle component type selection from autocomplete
  selectComponentType(event: any): void {
    const selected = event.option.value;
    const Id = event.option.value.Id;
    this.selectedComponentType.push(Id);
    debugger;
    if (!this.selectedComponentTypes.includes(selected)) {
      this.selectedComponentTypes.push(selected);
    }
    this.filterComponentTypes(''); // Reset the filter after selection
  }

  filterAssetALTList(): void {
    if (this.selectedAssetALTInput) {
      this.filteredAssetALTList = this.AssetSerialALTList.filter(alt =>
        alt.Name.toLowerCase().includes(this.selectedAssetALTInput.toLowerCase())
      );
    } else {
      this.filteredAssetALTList = [];
    }
  }

  onAssetALTSelect(event: any): void {
    const selectedAlt = event.option.value;
    // Add to selected list only if not already present
    if (!this.selectedAssetALT.some(alt => alt.Id === selectedAlt.Id)) {
      this.selectedAssetALT.push(selectedAlt);
    }
    // Clear input and filtered list
    this.selectedAssetALTInput = '';
    this.filteredAssetALTList = [];
  }
  removeAssetALT(alt: any): void {
    const index = this.selectedAssetALT.indexOf(alt);
    if (index >= 0) {

      this.selectedAssetALT.splice(index, 1);
    }
  }

  addImplementType(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value && this.filteredImplementTypes.some(c => c.Name.toLowerCase() === value.toLowerCase())
      && !this.selectedImplementTypes.some(c => c.Name.toLowerCase() === value.toLowerCase())) {
      const selectedImplementType = this.filteredImplementTypes.find(c => c.Name.toLowerCase() === value.toLowerCase());
      if (selectedImplementType) {
        this.selectedImplementTypes.push(selectedImplementType);
      }
    }
    event.chipInput!.clear();
    this.filterImplementTypes('');
  }

  // Filter implement types based on user input
  filterImplementTypes(value: string): void {
    if (value != '') {
      const filterValue = value.toLowerCase();
      this.filteredImplementTypes = this.implementTypeList.filter(impType =>
        impType.Name.toLowerCase().includes(filterValue)
      );
    }
  }
  // Select implement type from the autocomplete options
  selectImplementType(event: any): void {
    let Id = this.implementList.find(f => f.Name.split(':')[0].trim() == event.option.value.Name).Id;
    this.selectedImplementTypes.push(event.option.value.Name);
    this.selectedImplementType.push(event.option.value.Id);
    this.loadComponentTypes()
    this.GetAssetSerialSelectedImplements();
    if (this.implementTypeInput.nativeElement != undefined) {
      this.implementTypeInput.nativeElement.value = '';
    }
  }

  // Remove implement type from the selected list
  removeImplementType(implementType: any): void {
    const index = this.selectedImplementTypes.indexOf(implementType);
    if (index >= 0) {
      this.selectedImplementType.splice(index, 1);
      this.selectedImplementTypes.splice(index, 1);
    }
  }

  filterAssetMakes(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredAssetMakes = this.makeList.filter(assetMake =>
      assetMake.Name.toLowerCase().includes(filterValue) && !this.selectedAssetMakes.includes(assetMake)
    );
    if (value == "") {
      this.filteredAssetMakes = this.makeList
    }
  }

  addAssetMake(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const foundAssetMake = this.assetMakeList.find(assetMake => assetMake.Name.toLowerCase() === value.toLowerCase());
    if (foundAssetMake && !this.selectedAssetMakes.includes(foundAssetMake)) {
      this.selectedAssetMakes.push(foundAssetMake);
    }
    if (event.input) {
      event.input.value = ''; // Clear the input
    }
    this.filterAssetMakes('');
  }

  removeAssetMake(assetMake: any): void {
    const index = this.selectedAssetMakes.indexOf(assetMake);
    if (index >= 0) {
      this.selectedAssetMakes.splice(index, 1);
      this.selectedMake.splice(index, 1);
    }

    if (this.selectedAssetMakes.length == 0) {
      this.filteredAssetMakes = this.makeList;
    }
  }

  selectAssetMake(event: any): void {
    let Id = this.makeList.find(assetMake => assetMake.Name == event.value).Id;
    this.selectedMake.push(Id);
    const selectedAssetMake = event.value;
    if (selectedAssetMake && !this.selectedAssetMakes.includes(selectedAssetMake)) {
      this.selectedAssetMakes.push(selectedAssetMake);
    }
    if (this.assetMakeInput.nativeElement != undefined) {
      this.assetMakeInput.nativeElement.value = '';
    }
    this.filterAssetMakes('');
  }

  addAssetSerial(event: any): void {
    const value = event.value.trim();
    if (value && !this.selectedAssetSerials.some(serial => serial.Name === value)) {
      this.selectedAssetSerials.push({ Name: value });
    }
    this.assetSerialInput.nativeElement.value = '';
  }

  removeAssetSerial(serial: any): void {
    const index = this.selectedAssetSerials.indexOf(serial);
    if (index >= 0) {
      this.selectedAssetSerials.splice(index, 1);
      this.selectedAssetSerial.splice(index, 1);
    }
  }

  selectAssetSerial(event: any): void {
    const Id = event.option.value.Id;
    this.selectedAssetSerial.push(Id);
    const selectedSerial = event.option.value;
    if (!this.selectedAssetSerials.some(serial => serial.Name === selectedSerial.Name)) {
      this.selectedAssetSerials.push(selectedSerial);
    }
    this.assetSerialInput.nativeElement.value = '';

    this.onSelectAssetSerial_();
  }
  filterAssetSerialList(): void {
    if (this.selectedAssetSerialInput) {
      this.filteredAssetSerialList = this.AssetSerialList.filter(asset =>
        asset.Name.toLowerCase().includes(this.selectedAssetSerialInput.toLowerCase())
      );
    } else {
      this.filteredAssetSerialList = [];
    }
  }

  filterAssetTypes(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredAssetTypes = this.GETTypeList.filter(type =>
      type.Name.toLowerCase().includes(filterValue)
    );
  }
  addAssetType(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    const selectedAssetType = this.filteredAssetTypes.find(type => type.Name.toLowerCase() === value.toLowerCase());
    if (selectedAssetType && !this.selectedAssetTypes.includes(selectedAssetType)) {
      this.selectedAssetTypes.push(selectedAssetType);
    }
    if (input) {
      input.value = '';
    }
    this.filterAssetTypes('');
  }

  // Function to handle selection from the dropdown
  selectAssetType(event: MatAutocompleteSelectedEvent): void {
    const selectedAssetType = event.option.value;
    const Id = event.option.value.Id;
    this.selectGETTypeId.push(Id);

    if (!this.selectedAssetTypes.includes(selectedAssetType => selectedAssetType.Name === selectedAssetType.Name)) {
      this.selectedAssetTypes.push(selectedAssetType);
    }
    this.filteredImplementTypes = this.implementTypeList.filter(x => x.ImplementTypeId == Id);
    this.assetTypeInput.nativeElement.value = '';
    this.filterAssetTypes('');
  }

  loadGETTypes(): void {
    if (!this.selectedCustomer || this.selectedCustomer.length === 0) {
      this.GETTypeList = [];
      this.filteredAssetTypes = [];
      return;
    }

    // Jobsite empty array → treat as NULL
    const jobsiteIds =
      this.selectedJobsite && this.selectedJobsite.length > 0
        ? this.selectedJobsite
        : null;
    this._impService.getFilteredGETType(this.selectedCustomer, jobsiteIds)
      .subscribe(
        (res: ApiResponse<GenericIdNameVM[]>) => {
          console.log(res);
          if (res.Status === 1) {
            this.GETTypeList = res.Data || [];
            this.filteredAssetTypes = this.GETTypeList;
            console.log('API Error:', res.Message);
          } else {
            console.error('API Error:', res.Message);
          }
        },
        (error) => {
          console.error('API Error:', error);
        }
      );
  }

  // Function to remove an asset type from the selected list
  removeAssetType(assetType: any): void {
    const index = this.selectedAssetTypes.indexOf(assetType);
    if (index >= 0) {
      this.selectedAssetTypes.splice(index, 1);
      const idIndex = this.selectGETTypeId.indexOf(assetType.Id);
      if (idIndex >= 0) {
        this.selectedAssetType.splice(index, 1);
        this.selectGETTypeId.splice(index, 1);
      }
    }
  }

  filterModels(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredModels = this.modelList.filter(model => model.Name.toLowerCase().includes(filterValue))

  }

  addModel(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    const foundModel = this.modelList.find(model => model.Name.toLowerCase() === value.toLowerCase());
    if (foundModel && !this.selectedModels.includes(foundModel)) {
      this.selectedModels.push({ Name: value });
    }
    event.chipInput!.clear();
    this.filterModels('');
  }

  // Remove model from selected list
  removeModel(model: any): void {
    const index = this.selectedModels.indexOf(model);
    if (index >= 0) {
      this.selectedModel.splice(index, 1);

      this.selectedModels.splice(index, 1);

    }
  }

  // Select a model from the autocomplete dropdown
  selectModel(event: MatAutocompleteSelectedEvent): void {
    const model = event.option.value;
    const Id = event.option.value.Id;
    this.selectedModel.push(Id);
    if (!this.selectedModels.some(selectedModel => selectedModel.Name === model.Name)) {
      this.selectedModels.push(model);
    }
    if (this.modelInput.nativeElement != undefined) {
      this.modelInput.nativeElement.value = '';
    }
    //this.modelInput.nativeElement.value = '';
    this.filterModels('');
  }

  filterJobsites(value: string): void {
    const filterValue = value.toLowerCase();
    this.filteredJobsites = this.jobsiteList.filter(jobsite =>
      jobsite.Name.toLowerCase().includes(filterValue)

    );
  }

  addJobsite(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.trim();
    const isJobsiteValid = this.selectedJobsites.some(jobsite => jobsite.Name === value);
    if (value && isJobsiteValid && !this.selectedJobsites.some(jobsite => jobsite.Name === value)) {
      const newJobsite = this.selectedJobsites.find(jobsite => jobsite.Name === value);
      this.selectedJobsites.push(newJobsite);
    } else if (!isJobsiteValid) {
      console.warn("Invalid jobsite:", value);
    }
    if (input) {
      input.value = '';
    }

    this.filterJobsites(''); // Reset the filter
  }

  removeJobsite(jobsite: Jobsite): void {
    // Remove from selectedJobsites (object list)
    const index = this.selectedJobsites.findIndex(js => js.Id === jobsite.Id);
    if (index !== -1) {
      this.selectedJobsites.splice(index, 1);
    }
    // Remove from selectedJobsite (ID list)
    const idIndex = this.selectedJobsite.indexOf(jobsite.Id);
    if (idIndex !== -1) {
      this.selectedJobsite.splice(idIndex, 1);
    }
    if (this.selectedJobsite.length === 0) {
      this.GETTypeList = [];
      this.filteredAssetTypes = [];
      this.loadFamiliesForCustomer();
      this.loadMakes();
      return;
    }
    this.loadFamiliesForJobsite();
    this.loadMakes();
    this.loadGETTypes();
  }


  loadAllFamilyList() {
    this._favouriteDialogService.getllFamilyList().subscribe(res => {
      this.familyList = res;
      this.filteredFamilies = res;
    })
  }

  array_: ImplementTypeVM[] = [];
  FilterImplementType() {
    this.implementTypeList = this.copyimplementTypeList;
    if (this.selectGETTypeId != null && this.selectGETTypeId.length > 0) {
      this.array_ = [];
      this.selectGETTypeId.map(x => {
        let value = this.implementTypeList.filter(y => y.ImplementTypeId == x);
        console.log("Value___", x, value)
        if (value.length > 0) {
          if (this.array_.length > 0) {
            this.array_.concat(value);
            console.log("ifffpush", this.array_)

          } else {
            this.array_ = value;
            console.log("elsepush", this.array_)

          }
        }
      })
      this.implementTypeList = this.array_;
    } else {
      this.implementTypeList = this.copyimplementTypeList;
    }
  }

  LoadGETTypesList() {
    this._impService.GetAllGETTypes().subscribe(res => {
      this.GETTypeList = res;
      this.filteredAssetTypes = this.GETTypeList;
    })
  }

  getEquipmentWithoutImps() {
    this.NoImps = !this.NoImps
  }

  loadCustomers() {
    this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r || []; // Default to empty array if response is null
      this.filteredCustomers = [...this.customerList];
    }, error => {
      console.error('Error fetching customers:', error);
    });
  }

  loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
      return;
    this.selectedJobsite = [];
    this.jobsiteList = [];
    this.selectedEquipment = [];
    this.equipmentList = [];
    var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomer,
    }
    this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
        this.jobsiteList = r;
        this.filteredJobsites = r;
      }
    });
    this.LoadAllImplementTypesForCustomers();
  }

  onMakeSelectionChange(event: MatSelectChange): void {
    console.log('Selected Asset Makes:', event.value);
  }

  // Show the list of equipment for the selected jobsite.
  loadEquipmentForJobsite() {
    if (this.selectedJobsite == null)
      return;
    var params: number[] = this.selectedJobsite;
    this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
      if (r) {
        this.equipmentList = r;
        this.equipmentList_ = r
        this.filteredEquipmentList = r;
      }
    });
    this.LoadAllImplementTypesForJobsites();
  }

  onSelectEquipment() {

    if (this.selectedEquipment != null) {
      this.selectedImplementType = [];
      this.selectedImplement = [];
      this.selectedComponentType = [];

      //this._equipmentId = this.selectedEquipment;
      this.loadImplementsForEquipment();

    }
  }

  onSelectEquipment_(value) {

    this.selectedEquipment = []
    if (value != undefined) {
      console.log("t", value)
      this.selectedEquipment.push(value)
    }
    console.log("tyy", this.selectedEquipment)
    if (this.selectedEquipment != null) {
      this.selectedImplementType = [];
      this.selectedImplement = [];
      this.selectedComponentType = [];

      //this._equipmentId = this.selectedEquipment;
      this.loadImplementsForEquipment();
    }
  }
  onImplementSelected() {
    var params: ComponentTypeSelectionFilter = {
      Implements: this.selectedImplementType
    }
    this._favouriteDialogService.GetComponentTypesForSelectedImplements(params).subscribe(r => {
      this.componentTypeList = r;
      this.selectedComponentTypes = r;
    });

  }
  onComponentTypeSelected() {

  }

  //Component Type For Implements
  loadComponentTypes() {
    var params: ComponentTypeSelectionFilter = {
      Implements: this.selectedImplementType
    }
   // if (this.selectedImplementType.length > 0) {
      this._favouriteDialogService.GetComponentTypesForSelectedImplements(params).subscribe(r => {
        if (r) {
          this.filteredComponentTypes = r;

          if (this.filteredComponentTypes.length > 0) {

            this.componentTypeList = this.filteredComponentTypes;//this.familyList.filter(x=>)
          } else {
            // this.componentTypeList = this._favouriteDialogService.availableFamilyList
            this.componentTypeList = [];
          }
        }
      });
    // } else {
    // }
  }

  onImplementTypeSelected() {
    console.log("copyimplementList", this.copyimplementList)
    console.log("implementList", this.implementList)
    console.log("selectedImplementType", this.selectedImplementType)
    this.implementList = this.copyimplementList;
    if (this.selectedImplementType.length > 0) {

      let arra_ = [];
      this.selectedImplementType.map(x => {
        let value = this.implementList.find(z => z.ImplementTypeId == x);
        if (value != null)
          arra_.push(value);

      })

      this.implementList = arra_;
      // this.onImplementSelected();
    } else {
      this.implementList = this.copyimplementList;
    }

  }

  LoadAllImplements() {
    var params: ImplementSelectionFilter = {
      Equipments: [],
      Customers: [],
      Jobsites: [],
    }
    this._favouriteDialogService.GetImplementsAvailable(params).subscribe(r => {
      if (r) {
        this.implementList = r;
        this.copyimplementList = r;
      }
    });
  }

  LoadAllImplementTypes() {
    var params: ImplementSelectionFilter = {
      Equipments: [],
      Customers: [],
      Jobsites: [],
    }
    this._favouriteDialogService.GetAllImplementTypesAvailableWithGETTYpe(params).subscribe(r => {
      if (r) {
        this.implementTypeList = r;
        this.copyimplementTypeList = r;
      }
    });
  }
  LoadAllImplementTypesForEquipment() {
    var params: ImplementSelectionFilter = {
      Equipments: this.selectedEquipment,
      Customers: this.selectedCustomer,
      Jobsites: this.selectedJobsite,
    }
    this._favouriteDialogService.GetAllImplementTypesAvailableWithGETTYpe(params).subscribe(r => {
      if (r) {
        this.implementTypeList = r;
        this.copyimplementTypeList = r;
      }
    });
  }
  LoadAllImplementTypesForCustomers() {
    var params: ImplementSelectionFilter = {
      Equipments: [],
      Customers: this.selectedCustomer,
      Jobsites: [],
    }
    this._favouriteDialogService.GetAllImplementTypesAvailableWithGETTYpe(params).subscribe(r => {
      if (r) {
        this.implementTypeList = r;
        this.copyimplementTypeList = r;
      }
    });
  }

  LoadAllImplementTypesForJobsites() {
    var params: ImplementSelectionFilter = {
      Equipments: [],
      Customers: this.selectedCustomer,
      Jobsites: this.selectedJobsite,
    }
    this._favouriteDialogService.GetAllImplementTypesAvailableWithGETTYpe(params).subscribe(r => {
      if (r) {
        this.implementTypeList = r;
        this.copyimplementTypeList = r;
      }
    });
  }

  // Gets the list of implements that are currently loaded on the selected equipment.
  loadImplementsForEquipment() {
    if (this.selectedEquipment.length > 0) {
      var params: ImplementSelectionFilter = {
        Equipments: this.selectedEquipment,
        Customers: this.selectedCustomer,
        Jobsites: this.selectedJobsite,
      }

      this._favouriteDialogService.GetAllImplementTypesAvailableWithGETTYpe(params).subscribe(r => {
        if (r) {
          this.implementTypeList = r;
        }
      });
      this._favouriteDialogService.GetImplementsAvailable(params).subscribe(r => {
        if (r) {
          this.implementList = r;
        }
      });
    } else {
      this.implementTypeList = this.copyimplementTypeList;
      this.implementList = this.copyimplementList;

    }

  }

  // Implement Makes
  loadMakes() {
    this._equipmentService.getMakeList().subscribe(r => {

      this.makeList = r || [];
      this.filteredAssetMakes = [...this.makeList];
      this.filteredMakes = this.makeList;
    });

  }

  loadMakesForFamily() {

    if (!this.selectedCustomer?.length || !this.selectedJobsite?.length || !this.selectedFamily?.length) {
      this.loadMakesForJobsite(); // fallback
      return;
    }

    this._favouriteDialogService
      .GetMakesForFamily(
        this.selectedCustomer,
        this.selectedJobsite,
        this.selectedFamily
      )
      .subscribe(res => {
        this.makeList = res || [];
        this.filteredMakes = this.makeList;
      });
  }


  loadModelList() {
    if (this.selectedMakeUC == null)
      return;
    this.selectedModel = [];
    this.modelList = [];
    var params: ModelSelectionFilter = {
      Families: this.selectedFamily,
      Makes: this.selectedMakeUC


    }
    this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
      if (r) {
        this.modelList = r;
        this.filteredModels = r;


      }
    });

  }

  getEvalA() { this.EvalA = !this.EvalA }
  getEvalB() { this.EvalB = !this.EvalB }
  getEvalC() { this.EvalC = !this.EvalC }
  getEvalX() { this.EvalX = !this.EvalX }
  getOnEquipment() { console.log("this.onEqS:", this.onEqS) }

  submitSelection() {
    this.onEqS;
    this.selectedCustomer.map(x => x);
    this.selectedFamily.map(x => x);


    var params: SearchFilters = {

      customer: this.selectedCustomer,

      jobsite: this.selectedJobsite,
      equipment: this.selectedEquipment,
      make: this.selectedMake,
      makeUC: this.selectedMakeUC,
      model: this.selectedModel,
      implement: this.selectedImplement,
      evalA: this.EvalA,
      evalB: this.EvalB,
      evalC: this.EvalC,
      evalX: this.EvalX,
      onEq: this.onEqS,
      NoImps: this.NoImps,
      ImplementTypes: this.selectedImplementType,
      ComponentTypes: this.selectedComponentType,
      family: this.selectedFamily,
      assetSerial: this.selectedAssetSerial,
      GETType: this.selectGETTypeId,
      PageNumber: 0,
      PageSize: 0

    }

    console.log("search filters", params)
    this.searchFilters.emit(params);

  }

  reset: boolean = false;
  ResetFields() {
    debugger;
    this.selectedCustomer = [];
    this.selectedCustomers = [];
    this.selectedFamilies = [];
    this.selectedEquipments = [];
    this.selectedEquipments = [];
    this.selectedImplementTypes = [];
    this.selectedMakes = [];
    this.selectedAssetMake = [];
    this.selectedAssetMakes = [];
    this.selectedJobsite = [];
    this.selectedJobsites = [];
    this.selectedEquipment = [];

    this.selectedMake = [];
    this.selectedMakes = [];
    this.AssetSerialALTList = null;
    this.selectedMakeUC = [];
    this.selectedAssetTypes = [];
    this.selectedAssetType = [];
    this.selectedModel = [];
    this.selectedModels = [];
    this.selectedImplement = [];
    this.selectedImplementType = [];
    this.selectedImplementTypes = [];
    this.selectedComponentType = [];
    this.selectedComponentTypes = [];
    this.selectedFamily = [];
    this.selectedEquipment_ = ''
    this.selectedEquipment_ = null
    this.selectedAssetSerial = []
    this.selectedAssetSerial_ = ''
    this.selectedAssetSerial_ = null
    this.selectedAssetALT = []
    this.selectGETTypeId = []
    this.selectedAssetALT_ = ''
    this.selectedAssetALT_ = null
    this.showMultiple = true
    this.showMultipleAssetAlt = true
    this.showMultipleAssetSerial = true
    this.AssetSerialALTList = [];
    this.selectedAssetSerials = [];
    this.EvalA = true;
    this.EvalB = true;
    this.EvalC = true;
    this.EvalX = true;
    this.NoImps = false;
    this.reset = true;
    this.Reset.emit(this.reset);
    this.cdr.detectChanges();

  }

  getUserAlertsforDashbpard() {
    this._programImprovementService.getCurrentUserAlertsforDashboard().subscribe(res => {
      console.log(res)

      this.numberofNotifications = res.length
      if (this.numberofNotifications == 0) {
        this.showText = false;
      } else {
        this.showText = true;
      }


    })

  }
  showImplementDialog() {

    const dialogRef = this.dialog.open(PipForDashboardComponent, {
      data: {
        GET_Auto: this.GET_Auto


      }
    });
    dialogRef.afterClosed().subscribe(res => {
      console.log("res", res)
      this.getUserAlertsforDashbpard();

    });

  }

  //GetSerialbyModelFamilyMake

  GetSerialbyModelFamilyMake() {
    this.equipmentList = null
    var params: SerialNOSelectionFilter = {
      Families: this.selectedFamily,
      Makes: this.selectedMakeUC,
      Models: this.selectedModel,
      Jobsites: this.selectedJobsite
    }
    this._favouriteDialogService.GetSerialbyModelFamilyMake(params).subscribe(r => {
      if (r) {
        this.equipmentList = r;
        this.equipmentList_ = r

        this.filteredEquipmentList = r;

      }
    });

  }
  GetAssetSerialSelectedImplements() {
    var params: ComponentTypeSelectionFilter = {
      Implements: this.selectedImplementType
    }
    this._favouriteDialogService.GetAssetSerialSelectedImplements(params).subscribe(r => {
      this.AssetSerialList = r;
      this.AssetSerialList_ = r;
      this.filteredAssetSerials = r;

    });
  }


  GetAssetAltForSelectedSerial() {
    var params: AssetSerialSelectionFilter = {
      AssetSerial: this.selectedAssetSerial
    }
    this._favouriteDialogService.GetAssetAltForSelectedSerial(params).subscribe(r => {
      this.AssetSerialALTList = r;
      this.AssetSerialALTList_ = r;
    });
  }


  onSelectAssetSerial_() {
    var params: AssetSerialSelectionFilter = {
      AssetSerial: this.selectedAssetSerial
    }
    this._favouriteDialogService.GetAssetAltForSelectedSerial(params).subscribe(r => {
      this.AssetSerialALTList = r;
      this.AssetSerialALTList_ = r;
    });
  }


  changeModelAutoComplete(event) {
    const filterValue = event.target.value.toLowerCase();

    this.equipmentList = this.equipmentList_.filter(option => option.SerialNumber.toLowerCase().includes(filterValue));
  }


  getTitle(Id: number) {
    var gettitle
    console.log("ttttt", Id)
    if (Id != 0 || Id != null) {
      gettitle = this.equipmentList.find(u => u.Id === Id).SerialNumber;
    }
    return gettitle
  }

  loadFamiliesForCustomer() {
    var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomer,
    }
    if (this.selectedCustomer.length > 0) {
      this._favouriteDialogService.GetFamiliesForSelectedCustomers(params).subscribe(r => {
        if (r) {
          this.filteredFamilies = r;
          if (this.filteredFamilies.length > 0) {

            this.familyList = this.filteredFamilies;//this.familyList.filter(x=>)
          } else {
            this.familyList = this._favouriteDialogService.availableFamilyList
          }
        }
      });
    } else {
      this.loadAllFamilyList();
    }
  }

  loadFamiliesForJobsite() {
    if (!this.selectedCustomer?.length || !this.selectedJobsite?.length) {
      this.loadAllFamilyList();
      return;
    }
    this._favouriteDialogService
      .GetFamiliesForSelectedJobsite(this.selectedCustomer, this.selectedJobsite)
      .subscribe(res => {
        this.familyList = res || [];
        this.filteredFamilies = this.familyList;
        this.selectedFamily = [];
      });
  }

  loadMakesForJobsite() {

    if (!this.selectedCustomer?.length || !this.selectedJobsite?.length) {
      this.makeList = [];
      this.filteredMakes = [];
      return;
    }

    this._favouriteDialogService
      .GetMakesForJobsite(
        this.selectedCustomer,
        this.selectedJobsite
      )
      .subscribe(res => {
        this.makeList = res || [];
        this.filteredMakes = this.makeList;
      });
  }

  loadModelsForFamily() {

    if (!this.selectedCustomer?.length ||
      !this.selectedJobsite?.length ||
      !this.selectedFamily?.length) {

      this.modelList = [];
      this.filteredModels = [];
      return;
    }

    this._favouriteDialogService
      .GetModelsForFamilyNew(
        this.selectedCustomer,
        this.selectedJobsite,
        this.selectedFamily
      )
      .subscribe(res => {
        this.modelList = res;
        this.filteredModels = this.modelList;
      });
  }

  loadModelsForMake() {
    if (!this.selectedCustomer?.length ||
      !this.selectedJobsite?.length ||
      !this.selectedFamily?.length ||
      !this.selectedMakeUC?.length) {
      this.loadModelsForFamily();
      return;
    }

    this._favouriteDialogService
      .GetModelsForMake(
        this.selectedCustomer,
        this.selectedJobsite,
        this.selectedFamily,
        this.selectedMakeUC
      )
      .subscribe(res => {
        this.modelList = res;
        this.filteredModels = this.modelList;
      });
  }

  selectJobsite(event: MatAutocompleteSelectedEvent): void {
    const selectedJobsite = event.option.value;
    if (this.selectedJobsites.findIndex(js => js.Id === selectedJobsite.Id) === -1) {
      const Id = event.option.value.Id;
      this.selectedJobsite.push(Id)
      this.selectedJobsites.push({ Id: selectedJobsite.Id, Name: selectedJobsite.Name })
    }
    this.loadEquipmentForJobsite();
    this.loadFamiliesForJobsite();
    this.loadMakesForJobsite();
    this.loadGETTypes();
    if (this.jobsiteInput.nativeElement != undefined) {
      this.jobsiteInput.nativeElement.value = '';
    }
    //this.jobsiteInput.nativeElement.value = '';
    console.log("Selected Jobsites after selection:", this.selectedJobsites);
  }
  // Add Family from input


  // Add a family to the chip list
  addFamily(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add the family name if valid and not already selected
    const foundFamily = this.familyList.find(family => family.Name.toLowerCase() === value.toLowerCase());
    if (foundFamily && !this.selectedFamilies.includes(foundFamily.Name)) {
      this.selectedFamilies.push(foundFamily.Name); // Store the Name for display
    }

    // Clear the input value
    event.chipInput!.clear();
    this.filterFamilies('');
  }

  // Remove a family from the chip list
  removeFamily(familyName: string): void {
    const index = this.selectedFamilies.indexOf(familyName);
    if (index >= 0) {
      this.selectedFamilies.splice(index, 1);
      this.selectedFamily.splice(index, 1);
      this.filterFamilies('');
      this.loadMakesForJobsite();
    }
  }

  // Select a family from autocomplete
  selectFamily(event: any): void {
    const familyName = event.option.value;
    const selectedFamily = this.familyList.find(f => f.Name === familyName);

    if (selectedFamily && !this.selectedFamilies.some(f => f.Name === selectedFamily.Name)) {
      this.selectedFamilies.push(selectedFamily);
      this.selectedFamily.push(selectedFamily.Id);
    }

    this.GetSerialbyModelFamilyMake();
    this.loadMakesForFamily();
    this.familychipInput.nativeElement.value = '';
    this.filterFamilies('');
  }

  // Filter families based on user input
  filterFamilies(value: string): void {
    const filterValue = value.toLowerCase();

    this.filteredFamilies = this.familyList.filter(family =>
      family.Name.toLowerCase().includes(filterValue) && !this.selectedFamilies.includes(family.Name)
    );

    // Reset filtered families if input is empty
    if (value === '') {
      this.filteredFamilies = [...this.familyList];
    }
  }



  filterMakes(value: string): void {
    if (value != "") {
      const filterValue = value.toLowerCase();

      // Filter logic
      this.filteredMakes = this.makeList.filter(make =>
        make.Name.toLowerCase().includes(filterValue)
      );
    }

  }
  addMake(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    const selectedMake = this.filteredMakes.find(make => make.Name.toLowerCase() === value.toLowerCase());
    if (selectedMake && !this.selectedMakes.includes(selectedMake)) {
      this.selectedMakes.push(selectedMake);
    }
    if (input) {
      input.value = '';
    }
    this.filterMakes('');
  }

  // Function to handle selection from the dropdown
  selectMake(event: MatAutocompleteSelectedEvent): void {
    const selectedMake = event.option.value;
    if (!this.selectedMakes.some(make => make.Id === selectedMake.Id)) {
      if (this.selectedMake.find(x => x == selectedMake.Id) == null) {
        this.selectedMakeUC.push(selectedMake.Id);
      }
      this.selectedMakes.push(selectedMake.Name);
    }

    this.GetSerialbyModelFamilyMake();
    this.loadModelsForMake();
    this.makeInput.nativeElement.value = '';
    this.filterMakes('');
  }

  // Function to remove a make from the selected list
  removeMake(make: any): void {
    const index = this.selectedMakes.indexOf(make);

    if (index >= 0) {
      this.selectedMakeUC.splice(index, 1);

      this.selectedMakes.splice(index, 1);
      this.loadModelList();
    }
  }
  filterEquipments(value: any) {
    if (value != '') {
      const filterValue = value.toLowerCase();
      this.filteredEquipmentList = this.equipmentList.filter(equipment =>
        equipment.SerialNumber?.toLowerCase().includes(filterValue)
      );
      this.filterEquipments('');
    }
  }
  filterAssetSerail(value: any) {
    if (value != '') {
      const filterValue = value.toLowerCase();
      this.filteredAssetSerials = this.AssetSerialList.filter(equipment =>
        equipment.Name?.toLowerCase().includes(filterValue)
      );
      this.filterAssetSerail('');
    }
  }
  addEquipment(event: any) {
    const newEquipment = event.value || event;
    if (newEquipment && !this.selectedEquipments.some(eq => eq.SerialNumber === newEquipment.SerialNumber)) {
      this.selectedEquipments.push(newEquipment);
    }
    this.equipmentInput.nativeElement.value = '';
    this.filterEquipments('');
  }
  removeEquipment(equipment: any) {
    const index = this.selectedEquipments.indexOf(equipment);
    if (index >= 0) {

      this.selectedEquipments.splice(index, 1);
      this.selectedEquipment.splice(index, 1);
    }
  }

  selectEquipment(event: any) {
    const selectedEquipment = event.option.value;
    const Id = event.option.value.Id;
    this.selectedEquipment.push(Id);
    if (!this.selectedEquipments.some(eq => eq.SerialNumber === selectedEquipment.SerialNumber)) {
      this.selectedEquipments.push(selectedEquipment);
    }
    if (this.equipmentInput.nativeElement != undefined) {
      this.equipmentInput.nativeElement.value = '';

    }
  }
  selectedAssetAlts: any[] = [];
  filteredAssetAlts: any[] = [];
  filterAssetAlts() {
    this.filteredAssetAlts = this.AssetSerialALTList.filter(alt =>
      alt.Name.toLowerCase().includes(this.assetAltCtrl.value?.toLowerCase() || ''));
  }

  // Function to add asset alt to the list of selected ones
  addAssetAlt(event: any) {
    if (event.value) {
      const newAssetAlt = event.value;
      if (!this.selectedAssetAlts.includes(newAssetAlt)) {
        this.selectedAssetAlts.push(newAssetAlt);
      }
      this.assetAltCtrl.setValue('');
      this.filterAssetAlts(); // Reapply the filter
    }
  }

  // Function to remove asset alt from the list
  removeAssetAlt(alt: any) {
    const index = this.selectedAssetAlts.indexOf(alt);
    if (index >= 0) {
      this.selectedAssetAlts.splice(index, 1);
    }
  }

  // Function to handle selection of asset alt from autocomplete options
  selectAssetAlt(event: any) {
    const selected = event.option.value;
    if (!this.selectedAssetAlts.includes(selected)) {
      this.selectedAssetAlts.push(selected);
    }
  }
  ShowHidefield() {
    this.selectedEquipment = []
    this.selectedEquipment_ = ''
    this.selectedEquipment_ = null
    this.selectedEquipment_ = ""
    this.selectedEquipment_ = 0
    this.loadEquipmentForJobsite();

    this.showMultiple = !this.showMultiple;
  }

  ShowHidefieldAssetSerial() {
    this.selectedAssetSerial = []
    this.selectedAssetSerial_ = ''
    this.GetAssetSerialSelectedImplements();
  }
  ShowHidefieldAssetAlt() {
    this.selectedAssetALT = []
    this.selectedAssetALT_ = ''
    this.showMultipleAssetAlt = !this.showMultipleAssetAlt;
  }

  changeModelAutoCompleteAssetSerial(event) {
    const filterValue = event.target.value.toLowerCase();

    this.AssetSerialList = this.AssetSerialList_.filter(option => option.Name.toLowerCase().includes(filterValue));
  }

  changeModelAutoCompleteAssetAlt(event) {
    const filterValue = event.target.value.toLowerCase();
    this.AssetSerialALTList = this.AssetSerialALTList_.filter(option => option.Name.toLowerCase().includes(filterValue));
  }

  getTitleAssetSerial(Id: number) {
    if (Id != 0 || Id != null) {
      return this.AssetSerialList.find(u => u.Id === Id).Name;
    }

  }
  getTitleAssetAlt(Id: number) {
    if (Id != 0 || Id != null) {
      return this.AssetSerialALTList.find(u => u.Id === Id).Name;
    }
  }

  onSelectAssetAlt_(value) {
    this.AssetSerialALTList = []
    if (value != undefined) {
      console.log("t", value)
      this.AssetSerialALTList.push(value)
    }
  }

}
